<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <dash-sidebar
    defaultSelectedKeys="2"
    :menuItems="commonMenuItems.courseSubmitters"
    v-if="userRole === 'telas_course_submitters'"/>
    <dash-sidebar
    defaultSelectedKeys="2"
    :menuItems="commonMenuItems.admin"
    v-if="userRole === 'telas_telas_administrator'"/>
    <a-layout>
      <a-layout-content
        :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
      >
      <courses-list-tab
        :firstTabName="'New Course Form'"
        :firstTabDataSource="userCourses.courseSubmitterCourses.approved"
        :secondTabName="'Your Submitted Courses'"
        :secondTabDataSource="userCourses.courseSubmitterCourses.approved"
        :thirdTabName="'Courses submitted by others'"
        :thirdTabDataSource="userCourses.insitutionsCourses"
        :fourthTabName="'Summaries'"
        :fourthTabDataSource="accreditedReports"
        :userRole="'course_submitter'"
      />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';
import coursesListTab from '@src/views/dashboard/Courses-list-tab.vue';

export default {
  name: 'course-submitter',
  data() {
    return {
    };
  },
  components: {
    coursesListTab,
    dashSidebar,
  },
  computed: {
    ...mapState('dashboard', {
      userID: state => state.userDetails.user_id,
      userRole: state => state.userDetails.user_role,
      userCourses: state => state.courses,
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapState('user', {
      isActivated: state => state.userDetails.activated_by_admin,
    }),
    ...mapGetters('dashboard', {
      userProfileDetails: 'getUserProfileDetails',
    }),
    ...mapGetters('reports', {
      accreditedReports: 'accreditedReportMeta',
    }),
  },
  watch: {
    userToken() {
      const getAllCoursesArgs = {
        status: 'publish',
        role: 'institution',
        userToken: this.userToken,
        author_exclude: this.userID,
        'filter[meta_key]': 'institutionName',
        'filter[meta_compare]': '=',
        'filter[meta_value]': this.userProfileDetails.institution_name,
      };
      const userApprovedCoursesArgs = {
        status: 'publish',
        author: this.userID,
        role: this.userRole,
        userToken: this.userToken,
      };
      this.getCoursesByUser(getAllCoursesArgs);
      this.getCoursesByUser(userApprovedCoursesArgs);
    },
  },
  mounted() {
    this.$nextTick(() => {
      const getAllCoursesArgs = {
        status: 'publish',
        role: 'institution',
        userToken: this.userToken,
        author_exclude: this.userID,
        'filter[meta_key]': 'institutionName',
        'filter[meta_compare]': '=',
        'filter[meta_value]': this.userProfileDetails.institution_name,
      };
      const userApprovedCoursesArgs = {
        status: 'publish',
        author: this.userID,
        role: this.userRole,
      };
      this.getCoursesByUser(getAllCoursesArgs);
      this.getCoursesByUser(userApprovedCoursesArgs);
      const getReportsArgs = {
        'filter[meta_query][0][key]': 'review_status',
        'filter[meta_query][0][value]': 'accredited',
        'filter[meta_query][1][key]': 'course_submitter_id',
        'filter[meta_query][1][value]': this.userID,
        reviewStatus: 'accredited',
      };
      this.getReports(getReportsArgs);
    });
  },
  methods: {
    ...mapActions('user', {
      validateToken: 'validateToken',
    }),
    ...mapActions('dashboard', {
      getCoursesByUser: 'getCoursesByUser',
    }),
    ...mapActions('reports', {
      getReports: 'getReports',
    }),
  },
};
</script>
